import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StarConvertService {

    convertDecimalNumberToStars(value: number) {
        let starRating = '';
        const fullStars = Math.floor(value); // Get the number of full stars
        const modValue = value - fullStars; // Get the decimal part of the value
        let emptyStars: number = 0;
        let hasHalfStar: boolean = false;
        if(modValue <= 0.25) {
            emptyStars = 5 - fullStars; // Calculate remaining empty stars
        } else {
            hasHalfStar = modValue > 0.25 && modValue <= 0.74; // Check if there should be a half star
            emptyStars = 5 - fullStars - 1;
        }
        
        // Add full stars
        for (let i = 0; i < fullStars; i++) {
            starRating += '★';
        }

        // Add half star or another full star based on modValue
        if (hasHalfStar && modValue >= 0.25 && modValue < 0.74) {
            starRating += '<img src="../../assets/images/half-star.png" class="half-star" />'; // Half star icon

        } 
        else if (!hasHalfStar && modValue >= 0.75) {
            starRating += '★'; // Full star icon
        }

        // Add empty stars to fill up the 5-star rating
        if(emptyStars != (0)){
            for (let i = 0; i < emptyStars; i++) {
                starRating += '<i class="fa fa-star-o"></i>'; // Empty star icon
            }
            // Modified: Append the empty stars
        starRating += '☆'.repeat(emptyStars); // Empty stars

        } else {
            starRating;
        }

        
        return starRating
    }
}